import { memo } from 'react'
import { Row, Col, Container } from "react-bootstrap";


const Transactions = ({ transactions }) => {
    return (

        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col md={5} className='mrgauto'>
                        <Row className='g-0 mb-3'>
                            <Col>
                                <table className='table table-hover table-bordered table-striped'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Date</div>
                                            </th>
                                            <th className='text-center'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Amount</div>
                                            </th>
                                            <th className='text-center'>
                                                <div className='font-size2 color-text text-capitalize py-2'>NAV</div>
                                            </th>
                                            <th className='text-center'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Units</div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {!!transactions?.length &&
                                            transactions?.map((element, index) =>
                                                <tr key={index}>
                                                    <td className='text-left'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{element?.date}</div>
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{element?.amount}</div>
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{element?.nav}</div>
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{element?.units}</div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

        </>
    )
}

export default memo(Transactions)